// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"825386d9","471":"b6ea6e9d","615":"e967a6ef","900":"bd72be8b","936":"6de458a8"}[chunkId] + ".chunk.js";
};